const $inject = [
  "$scope",
  "$uibModalInstance",
  "$timeout",
  "RegistrationService",
  "items"
];

class AccountModalController {
  /**
   * @constructor
   * @param $scope
   * @param $uibModalInstance
   * @param $timeout
   * @param RegistrationService
   * @param items
   */
  constructor(
    $scope,
    $uibModalInstance,
    $timeout,
    RegistrationService,
    items
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.timeout = $timeout;

    this.forgotPswSent = false;
    this.forgottenResponseData = {};
    this.resetPswSent = false;

    this.registrationService = RegistrationService;
    this.resetPasswordSuccessUrl = "/app";
    this.items = items;
  }

  /**
   * Reset the user's password
   */
  sendResetEmailPassword(form) {
    var self = this;
    this.submitted = true;

    if (form.$valid) {
      this.loading = true;

      var handleSuccess = function (response) {
        self.loading = false;
        if (!response.data.error) {
          self.forgotPswSent = true;
          self.forgottenResponseData = response.data;
          self.items.title = response.data.data.title;
        }
        else {
          handleError(response);
        }
      };

      var handleError = function (response) {
        self.loading = false;
        self.errorMessage = response.data.message;
      };

      this.registrationService.sendResetEmailPassword(this.email, this.mrnNumber, handleSuccess, handleError);
    }
  }

  /**
   * Reset the user's password
   */
  resetPassword(form) {
    if (window.globalData && window.globalData.hash) {
      var self = this;
      this.submitted = true;

      if (form.$valid) {
        this.loading = true;

        var handleSuccess = function (response) {
          self.loading = false;
          if (!response.data.error) {
            self.loading = false;
            self.resetPswSent = true;
            //self.$uibModalInstance.close(self.items);
          }
          else {
            handleError(response);
          }
        };

        var handleError = function (response) {
          self.loading = false;
          self.errorMessage = "An error occurred.";
        };

        this.registrationService.resetPassword(window.globalData.hash, this.password, handleSuccess, handleError);
      }
    }
  }

  /**
   * Close the modal
   */
  cancel(callbackFn) {
    this.$uibModalInstance.dismiss("cancel");
    if (callbackFn) {
      callbackFn();
    }
  }
}

AccountModalController.$inject = $inject;

export default AccountModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/account/controllers/modals/account.modal.controller.js
 **/